import PropTypes from 'prop-types';

import { pricingModelEnum, additionalFeesEnum, fallbackOptionModeEnum } from './enums';

export default PropTypes.shape({
  name: PropTypes.string,
  index: PropTypes.number,
  description: PropTypes.string,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      sellerProviderId: PropTypes.number,
      serviceId: PropTypes.number,
    }),
  ),
  pricingModel: PropTypes.oneOf(Object.values(pricingModelEnum)),
  flatRate: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }),
  additionalFees: PropTypes.shape({
    mode: PropTypes.oneOf(Object.values(additionalFeesEnum)),
    percentage: PropTypes.number,
    flatRate: PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.number,
    }),
  }),
  fallbackOption: PropTypes.shape({
    mode: PropTypes.oneOf(Object.values(fallbackOptionModeEnum)),
    cartPercentage: PropTypes.number,
    flatRate: PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.number,
    }),
  }),
  isActive: PropTypes.bool,
});
